<template>
  <div id="app">
    <keep-alive
      :exclude="['detailstheme','post','playVideo','login','privacyPolicy','termsOfService','moneyRecharge','recharge','modifyAddress','articleLabel','homeArticleLabel','friend','poetryBody','courseWare','member']">
      <router-view @loading="loading" @closeLoading="closeLoading" class="child-view"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import Wait from '@/components/base/wait'

export default {
  components: {
    Wait
  },
  data () {
    return {
      transitionName: ''
    }
  },
  methods: {
    loading (waitMsg) {
      this.waitMsg = waitMsg
      this.waiting = true
    },
    closeLoading () {
      this.waiting = false
    }
  },
  beforeRouteUpdate (to, from, next) {
    let isBack = this.$router.isBack
    if (isBack) {
      this.transitionName = 'slide-right'
    } else {
      this.transitionName = 'slide-left'
    }
    this.$router.isBack = false
    next()
  }
}
</script>

<style lang="scss">
  @import "~@/assets/sass/index.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue